import { defineComponent as _defineComponent } from 'vue';
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "context-sidebar"
};
import { onMounted, shallowRef } from 'vue';
import sidebarContext, { SIDEBAR_STATE_CHANGED } from '../services/AppSidebarContext';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PortalContextSidebar',
    setup(__props) {
        const component = shallowRef(null);
        onMounted(() => sidebarContext.$on(SIDEBAR_STATE_CHANGED, onSidebarStateChanged));
        function onSidebarStateChanged() {
            component.value = sidebarContext.component;
        }
        return (_ctx, _cache) => {
            return (component.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    (_openBlock(), _createBlock(_resolveDynamicComponent(component.value)))
                ]))
                : _createCommentVNode("", true);
        };
    }
});
